import { createSelector } from 'reselect';

import getCart from './getCart';

const getCartHasCoords = createSelector(
  getCart,
  cart => Boolean(cart && cart.lat && cart.lng),
);

export default getCartHasCoords;
